import { ReactElement, useEffect } from 'react';
import classnames from 'classnames';

import { Icon } from '@betrybe/ada-react';

import { useToastNotification } from '../../../contexts';

function ToastNotification(): ReactElement {
  const [currentState, dispatch] = useToastNotification();

  useEffect(() => {
    setTimeout(() => {
      dispatch({ type: 'close', payload: { title: '', text: '' } });
    }, 15000);
  }, [currentState.state, dispatch]);

  if (currentState.state === 'closed') {
    return <> </>;
  }

  const handleOnClick = () =>
    dispatch({ type: 'close', payload: { title: '', text: '' } });

  return (
    <div
      className={classnames('notification', currentState.notificationClassName)}
    >
      <div className="notification-icon">{currentState.notificationIcon}</div>
      <div className="notification-text">
        <h6>{currentState.notificationTitle}</h6>
        <p>{currentState.notificationText}</p>
      </div>
      <button className="notification-close" onClick={handleOnClick}>
        <Icon
          name="clear"
          className="notification-close-icon"
          height={10}
          width={10}
        />
      </button>
    </div>
  );
}

export default ToastNotification;
